module.exports = __webpack_public_path__ + "img/electricelephant.5423dba3.svg";